var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBarRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.668,
    height: 16,
    viewBox: "0 0 14.668 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-bar-right",
    transform: "translate(-6.75 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M22.694,10.319a.667.667,0,0,1,.944,0l4,4a.667.667,0,0,1,0,.944l-4,4a.668.668,0,1,1-.944-.944l3.529-3.528-3.529-3.528a.667.667,0,0,1,0-.944Z",
    transform: "translate(-6.416 -2.291)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M10.75,12.5a.667.667,0,0,1,.667-.667h8.667a.667.667,0,0,1,0,1.333H11.417A.667.667,0,0,1,10.75,12.5Zm-3.333,8a.667.667,0,0,1-.667-.667V5.167a.667.667,0,0,1,1.333,0V19.833A.667.667,0,0,1,7.417,20.5Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBarRight);
export default __webpack_public_path__ + "static/media/arrow-bar-right.b7ef82c0dee3d8629c36cdf43fed0f71.svg";
export { ForwardRef as ReactComponent };